import React from "react";
import { CloseOutlined } from "@ant-design/icons";
import { Modal, Button, Typography } from "antd";
import ProspectusesTable from "./ProspectusesTable";
import { useIntl } from "react-intl";
const { Title } = Typography;
const CreateFileModal = (props) => {
  const { onHide, visible, prospectuses, createFileMode } = props;
  const intl = useIntl();

  const onCancel = () => {
    onHide();
  };

  return (
    <Modal
      closable={false}
      footer={null}
      maskClosable={false}
      title={null}
      width={"fit-content"}
      style={{ top: 20, padding: 0 }}
      styles={{
        body: {
          padding: 0,
        },
      }}
      open={visible}
      destroyOnClose={true}
    >
      <div>
        <div className="header" style={{ height: "40px" }}>
          <Button
            style={{ position: "absolute", left: 10, top: 10 }}
            className="closeBtn"
            type="text"
            shape="circle"
            icon={<CloseOutlined />}
            onClick={onCancel}
          />
        </div>
        <Title level={3} ellipsis style={{ margin: "0px 20px 10px 20px" }}>
          {intl.formatMessage({
            id:
              createFileMode === "btl"
                ? "app.prospectuses.createBtlFileTitle"
                : "app.prospectuses.createKerenFileTitle",
          })}
        </Title>
        <ProspectusesTable
          prospectuses={prospectuses}
          createFileMode={createFileMode}
          onHide={onHide}
        />
      </div>
    </Modal>
  );
};

export default CreateFileModal;
